import CryptoJS from 'crypto-js';

const decryptData = (encryptedData, secretKey) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  const decryptedJsonString= bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedJsonString);
};

export default decryptData;